import { Component, Input, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';

@Component({
  selector: 'skc-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.less']
})
export class ImageComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-width') width = '20em';
  @Input('skc-height') height = '20em';
  @Input('skc-image-width') imageWidth = '10em';
  @Input('skc-image-height') imageHeight = '20em';
  @Input('skc-src-img') imageSrc = './assets/icons/picture.svg';
  @Input('skc-image-color') imageColor;
  constructor() {
    super();
  }

  ngOnInit() {}
}
